import React, { useState, useEffect } from 'react';

const DEFAULT_DHCP = {
  name: 'dhcp1',
  interface: 'bridge1',
  network: '192.168.88.0/24',
  pool_start: '192.168.88.100',
  pool_end: '192.168.88.200',
  gateway: '192.168.88.1',
  dns: '8.8.8.8',
  lease_time: '10m',
};

export default function StepDHCP({ data, onChange, onNext, onBack, interfaceNames }) {
  const [servers, setServers] = useState(data && data.length > 0 ? data : [{ ...DEFAULT_DHCP }]);

  useEffect(() => {
    if (data && data.length > 0) setServers(data);
  }, [data]);

  const update = (index, key, value) => {
    const updated = [...servers];
    updated[index] = { ...updated[index], [key]: value };
    setServers(updated);
    onChange(updated);
  };

  const add = () => {
    const i = servers.length + 1;
    const updated = [...servers, { ...DEFAULT_DHCP, name: 'dhcp' + i, network: `192.168.${80 + i * 10}.0/24`, pool_start: `192.168.${80 + i * 10}.100`, pool_end: `192.168.${80 + i * 10}.200`, gateway: `192.168.${80 + i * 10}.1` }];
    setServers(updated);
    onChange(updated);
  };

  const remove = (index) => {
    if (servers.length <= 1) return;
    const updated = servers.filter((_, i) => i !== index);
    setServers(updated);
    onChange(updated);
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">📡 ตั้งค่า DHCP Server</h2>
        <p className="text-gray-500 dark:text-gray-400">ตั้งค่าเซิร์ฟเวอร์แจก IP Address อัตโนมัติให้เครื่องลูกข่ายในแต่ละเครือข่าย</p>
      </div>

      <div className="space-y-4">
        {servers.map((dhcp, index) => (
          <div key={index} className="p-5 bg-gradient-to-br from-gray-50 to-white dark:from-gray-700/50 dark:to-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-600 shadow-sm">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-lg flex items-center justify-center text-sm font-bold shadow-md">{index + 1}</span>
                <span className="font-bold text-gray-900 dark:text-white">{dhcp.name}</span>
              </div>
              <button onClick={() => remove(index)} className="btn-danger" disabled={servers.length <= 1}>ลบ</button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="label">ชื่อ DHCP Server</label>
                <input type="text" value={dhcp.name} onChange={e => update(index, 'name', e.target.value)} className="input-field" />
              </div>
              <div>
                <label className="label">Interface</label>
                <select value={dhcp.interface} onChange={e => update(index, 'interface', e.target.value)} className="input-field">
                  {(interfaceNames && interfaceNames.length > 0 ? interfaceNames : ['bridge1', 'bridge-lan', 'ether1', 'ether2', 'ether3', 'ether4', 'ether5', 'sfp-sfpplus1']).map(iface => (
                    <option key={iface} value={iface}>{iface}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="label">เครือข่าย (CIDR)</label>
                <input type="text" value={dhcp.network} onChange={e => update(index, 'network', e.target.value)} className="input-field" placeholder="192.168.88.0/24" />
              </div>
              <div>
                <label className="label">Gateway</label>
                <input type="text" value={dhcp.gateway} onChange={e => update(index, 'gateway', e.target.value)} className="input-field" placeholder="192.168.88.1" />
              </div>
              <div>
                <label className="label">ช่วง IP เริ่มต้น</label>
                <input type="text" value={dhcp.pool_start} onChange={e => update(index, 'pool_start', e.target.value)} className="input-field" />
              </div>
              <div>
                <label className="label">ช่วง IP สิ้นสุด</label>
                <input type="text" value={dhcp.pool_end} onChange={e => update(index, 'pool_end', e.target.value)} className="input-field" />
              </div>
              <div>
                <label className="label">DNS Server</label>
                <input type="text" value={dhcp.dns} onChange={e => update(index, 'dns', e.target.value)} className="input-field" />
              </div>
              <div>
                <label className="label">ระยะเวลาเช่า (Lease Time)</label>
                <select value={dhcp.lease_time} onChange={e => update(index, 'lease_time', e.target.value)} className="input-field">
                  <option value="5m">5 นาที</option>
                  <option value="10m">10 นาที</option>
                  <option value="30m">30 นาที</option>
                  <option value="1h">1 ชั่วโมง</option>
                  <option value="3d">3 วัน</option>
                  <option value="1w">1 สัปดาห์</option>
                </select>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button onClick={add} className="mt-4 px-4 py-3 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl text-gray-500 dark:text-gray-400 hover:border-green-500 hover:text-green-500 transition-colors w-full font-medium text-sm">
        + เพิ่ม DHCP Server
      </button>

      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="btn-secondary">← ย้อนกลับ</button>
        <button onClick={onNext} className="btn-primary">ถัดไป ({servers.length} ตัว)</button>
      </div>
    </div>
  );
}
